import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import FileUploadSection from './FileUploadSection'

interface DocumentsTabContentProps {
  salesforceCreditId: string
}

const DocumentsTabContent = ({ salesforceCreditId }: DocumentsTabContentProps) => {
  const [_, makeTestId] = useNameFormatter('DocumentsTabContent')

  return (
    <div data-testid={makeTestId('')}>
      <FileUploadSection salesforceCreditId={salesforceCreditId} />
    </div>
  )
}

export default DocumentsTabContent
